import React from 'react';
import { useData } from '../../context/DataContext';
import '../../styles/pages/Vision.css';

const Vision = () => {
    const { data, getVision, getUIText, loading, error } = useData();
    const vision = getVision();
    const visionUI = getUIText('vision') || {};
    const images = data?.images || {};
    const backgroundImage = images?.backgrounds?.vision;

    if (loading) {
        return (
            <main className="vision-page mandala-bg">
                <div className="loading-container">
                    <div className="loading-spinner"></div>
                    <p>Loading vision...</p>
                </div>
            </main>
        );
    }

    if (error) {
        return (
            <main className="vision-page">
                <div className="error-container">
                    <p>Error loading data: {error}</p>
                </div>
            </main>
        );
    }

    const heroStyle = backgroundImage ? {
        '--page-hero-bg': `url(${backgroundImage})`
    } : {};

    return (
        <main className="vision-page mandala-bg">
            {/* Hero Section */}
            {/* Hero Section */}
            <section className={`page-hero${backgroundImage ? ' has-bg-image' : ''}`} style={heroStyle}>
                <div className="container">
                    <h1 className="page-title">{visionUI?.pageTitle || 'Our Vision & Mission'}</h1>
                    <p className="page-subtitle">{visionUI?.pageSubtitle || vision?.statement}</p>
                </div>
            </section>



            {/* Mission Section */}
            {vision?.mission && (
                <section className="mission-section section">
                    <div className="container">
                        <div className="mission-content">
                            <h2 className="section-title">Our Mission</h2>
                            <p className="mission-text">{vision.mission}</p>
                        </div>
                    </div>
                </section>
            )}

            {/* Vision Statement Section */}
            {vision?.statement && (
                <section className="vision-statement-section section">
                    <div className="container">
                        <div className="vision-statement-content">
                            <h2 className="section-title light-text">Our Vision</h2>
                            <p className="vision-statement-text">
                                "{vision.statement}"
                            </p>
                        </div>
                    </div>
                </section>
            )}

            {/* Strategic Goals Section */}
            {vision?.strategicGoals?.length > 0 && (
                <section className="goals-section section">
                    <div className="container">
                        <div className="section-header">
                            <h2 className="section-title">{visionUI?.goalsSection?.title || 'Strategic Goals'}</h2>
                            <p className="section-subtitle">{visionUI?.goalsSection?.subtitle}</p>
                        </div>
                        <div className="goals-grid">
                            {vision.strategicGoals.map((goal, index) => (
                                <div key={index} className="goal-card">
                                    <span className="goal-number">{goal.number}</span>
                                    <h3 className="goal-title">{goal.title}</h3>
                                    <p className="goal-description">{goal.description}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
            )}

            {/* Future Section */}
            {vision?.future && (
                <section className="future-section section">
                    <div className="container">
                        <div className="future-grid">
                            <div className="future-content">
                                <h2 className="section-title">{vision.future.headline || visionUI?.futureSection?.title || 'Looking to the Future'}</h2>
                                {vision.future.paragraphs?.map((paragraph, index) => (
                                    <p key={index} className="future-text">{paragraph}</p>
                                ))}
                            </div>
                            <div className="future-image">
                                <img
                                    src={images?.content?.future || images?.backgrounds?.vision || 'https://images.unsplash.com/photo-1444858291040-58f756a3bdd6?auto=format&fit=crop&q=80&w=800'}
                                    alt="Looking to the Future"
                                />
                            </div>
                        </div>
                    </div>
                </section>
            )}
        </main>
    );
};

export default Vision;
